import EntityChallengesLockedForm from './EntityChallengesLockedForm';

export default EntityChallengesLockedForm;
